import { render, staticRenderFns } from "./productGroup.vue?vue&type=template&id=5e9b33f2&scoped=true&"
import script from "./productGroup.vue?vue&type=script&lang=js&"
export * from "./productGroup.vue?vue&type=script&lang=js&"
import style0 from "./productGroup.vue?vue&type=style&index=0&id=5e9b33f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9b33f2",
  null
  
)

export default component.exports